"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var active_svg_1 = __importDefault(require("@assets/widgets/user/active.svg"));
var inactive_svg_1 = __importDefault(require("@assets/widgets/user/inactive.svg"));
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        copyLinkDiv: {
            display: 'flex',
        },
        copyIcon: {
            marginRight: 5,
        },
    });
});
function StatusIcon(_a) {
    var state = _a.state;
    // const [t] = useTranslation()
    var classes = useStyles();
    return (react_1.default.createElement("img", { className: classes.copyIcon, src: state === 'ACTIVE' ? active_svg_1.default : inactive_svg_1.default, alt: "Copy short link" }));
}
exports.default = StatusIcon;
